// extracted by mini-css-extract-plugin
export default {"problem_classes":"statisticsProblemClasses_problem_classes__O1I4H","header":"statisticsProblemClasses_header__f0mjq","body":"statisticsProblemClasses_body__yDsZT"};